(function Ecards($, Adzuki)
{
	"use strict";

	var Ecards = {};

	/**
	 * When clicking on the + to show more emails
	 * for the ecard recipients
	 * 
	 * @return {void}
	 */
	Ecards.showMoreEmails = function showMoreEmails()
	{
		$('.show-more-ecard-emails').click(function onShowMoreEmailsClick(e)
		{
			var $target = $(e.currentTarget);

			e.preventDefault();

			$target.parent().find('.additional_emails').toggleClass('hidden');
		});
	};

	/**
	 * When clicking on magnifying glass icon
	 * to open the ecard, template or schedule preview in a modal.
	 *
	 * @param {string} type
	 * 
	 * @return {void}
	 */
	Ecards.viewByType = function view(type)
	{
		$('.view-ecard-model').click(function onViewEcardModelClick(e)
		{
			var $target      = $(e.currentTarget);
			var $modal_title = $('.modal-title');
			var $modal_body  = $('.modal-body');
			var model_id     = $target.data('model-id');

			e.preventDefault();

			Adzuki.Ajax.get('/Ecards/view/' + model_id + '/' + type).then(function success(response)
			{
				$('#modalWindow').modal();

				$modal_title.html('View eCard' + (type === 'ecard' ? '' : ' ' + Adzuki.String.capitalize(type)));
				$modal_body.html(response);
			});
		});
	};

	/**
	 * When clicking on magnifying glass icon
	 * to open a modal to view the scene or photo image.
	 *
	 * @return {void}
	 */
	Ecards.viewCustomContent = function viewCustomContent()
	{
		$('.view-custom-content').click(function onViewCustomContentClick(e)
		{
			var $target      = $(e.currentTarget);
			var $modal_title = $('.modal-title');
			var $modal_body  = $('.modal-body');
			var content_id   = $target.data('content-id');
			var content_type = $target.data('content-type');

			e.preventDefault();

			Adzuki.Ajax.get('/Ecards/viewContent/' + content_type + '/' + content_id).then(function success(response)
			{
				$('#modalWindow').modal();

				$modal_title.html(response.name);
				$modal_body.html('<img src="' + response.image + '" class="img-responsive img-thumbnail center-block">');
			});
		});
	};

	$(document).ready(function onDocumentReady()
	{
		Adzuki.onload('/Ecards/queue', function onLoadQueue()
		{
			// apply filter when the dropdown to filter changes
			$('#queue_filter').change(function onFilterQueueChange(e)
			{
				var url = '/Ecards/queue/filter_by:' + $(e.target).val();

				window.location = Adzuki.get_url(url);
			});

			Ecards.showMoreEmails();

			Ecards.viewByType('ecard');
		});

		Adzuki.onload('/Ecards/sent', function onLoadSent()
		{
			Ecards.showMoreEmails();

			Ecards.viewByType('ecard');
		});

		Adzuki.onload('/Ecards/templates', function onLoadTemplates()
		{
			Ecards.viewByType('template');
		});

		Adzuki.onload('/Ecards/schedules', function onLoadTemplates()
		{
			Ecards.viewByType('schedule');
		});

		Adzuki.onload('/Ecards/customContent', function onLoadCustomContent()
		{
			Ecards.viewCustomContent();
		});
	});

	Adzuki.Erez.Ecards = Ecards;
}(jQuery, window.Adzuki || {}));
